<div class="tw-relative tw-ml-3 tw-h-full tw-p-5 tw-font-['Rubik',sans-serif]">
  <div class="transparent-background"></div>
  <p class="tw-font-semibold tw-text-lg tw-text-main-text tw-mb-5">
    {{ greeting | translate : { user: currentUser?.name } }} 👋🏻
  </p>
  <p class="tw-mb-6 tw-mt-5 tw-text-lg tw-text-main-text">{{ 'dashboard.summary' | translate }}</p>

  <div class="tw-grid tw-grid-cols-1 tw-items-stretch tw-gap-6 xl:tw-grid-cols-3">
    <div class="tw-col-span-1 tw-min-w-0 tw-w-full tw-space-y-6 xl:tw-col-span-2">
      <section class="tw-grid tw-grid-cols-1 tw-gap-4 sm:tw-grid-cols-2 2xl:tw-grid-cols-3">
        @if (customer) {
          <mh-nps-widget-container [customerId]="customer.id" [productId]="1" [enabled]="followupEnabled" />
          <mh-nps-widget-container [customerId]="customer.id" [productId]="2" [enabled]="onsiteEnabled" />
          <mh-iro-widget-container [customerId]="customer.id" [enabled]="onlineEnabled" />
          <mh-semantic-index-widget-container [customerId]="customer.id" [enabled]="semanticEnabled" />
          <mh-resolved-cases-widget-container [customerId]="customer.id" [enabled]="casesEnabled" />
          <mh-automation-rate-widget-container [customerId]="customer.id" [enabled]="conciergeEnabled" />
        }
      </section>

      <section>
        <mh-recommendation-table-widget
          [hotelRecommendations]="hotelRecommendations"
          [loadingRecommendations]="loadingRecommendations"
        >
        </mh-recommendation-table-widget>
      </section>
    </div>

    <section
      class="tw-sticky tw-top-5 tw-h-full tw-w-full tw-min-w-0 tw-rounded-xl tw-border tw-border-gray-100 tw-bg-white tw-p-4 tw-shadow-md"
      aria-labelledby="guest-requests-widget-title"
    >
      @if (customer) {
        <mh-service-request-widget
          class="tw-block tw-h-full"
          [currentCustomer]="customer"
          [conciergeEnabled]="conciergeEnabled"
        ></mh-service-request-widget>
      }
    </section>
  </div>
</div>
